import { render, staticRenderFns } from "./AppText.vue?vue&type=template&id=4871311e&scoped=true&functional=true&"
import script from "./AppText.vue?vue&type=script&lang=js&"
export * from "./AppText.vue?vue&type=script&lang=js&"
import style0 from "./AppText.vue?vue&type=style&index=0&id=4871311e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4871311e",
  null
  
)

export default component.exports